import HeaderWithoutMenu from '../components/common/landingPage/HeaderWithoutMenu';
import Footer from '../components/common/landingPage/Footer';

const Policies = [
  {
    question: 'Responsable del tratamiento', // 1
    answers: [
      {
        text: 'El Responsable del Tratamiento de tus datos personales es Loaded Colombia SAS, sociedad comercial identificada con NIT 901910428-1, con domicilio principal en Bogotá D.C., Colombia, quien opera la marca comercial "Flowex Pay" (en adelante, "Flowex Pay" o "nosotros").',
      },
      {
        text: 'Canales de contacto para asuntos de protección de datos:',
        subText: [
          'Correo: soporte@flowexpay.com',
          'WhatsApp: +57 320 408 8142',
          'Horario de atención: lunes a viernes, 9:00 a.m. a 5:00 p.m. (hora de Colombia).',
        ],
      },
    ],
  },
  {
    question: 'Marco legal aplicable', // 2
    answers: [
      {
        text: 'Esta Política se expide en cumplimiento de la Ley 1581 de 2012, el Decreto 1377 de 2013 (compilado en el Decreto 1074 de 2015), la Circular Externa 002 de 2015 de la Superintendencia de Industria y Comercio (SIC) y demás normas concordantes sobre protección de datos personales en Colombia, así como de las disposiciones de SAGRILAFT y UIAF aplicables al tratamiento de datos con ocasión de actividades de prevención del lavado de activos y financiación del terrorismo.',
      },
    ],
  },
  {
    question: '¿Qué datos recopilamos?', // 3
    answers: [
      {
        type: 'circle',
        text: 'Dependiendo del servicio que utilices, recolectamos las siguientes categorías de datos personales:',
        subText: [
          'Datos de identificación: nombres y apellidos, tipo y número de documento (cédula, pasaporte, NIT), fecha y lugar de nacimiento, nacionalidad, género, firma.',
          'Datos de contacto: correo electrónico, número de teléfono, dirección de residencia o domicilio comercial, ciudad y país.',
          'Datos socioeconómicos y transaccionales: actividad económica, ocupación, fuente y origen de fondos, ingresos, información bancaria (números de cuenta, IBAN, SWIFT/BIC, CLABE, llave PIX, routing number), historial y detalles de operaciones (monto, fecha, beneficiario, país destino, rail de pago).',
          'Datos biométricos y de verificación KYC: fotografías de documentos de identidad, selfies (incluidos "pruebas de vida" o video-selfies), datos biométricos faciales utilizados únicamente para verificación (vía nuestro aliado Bridge y proveedores autorizados).',
          'Datos técnicos y de uso: dirección IP, identificadores de dispositivo, sistema operativo, versión de la aplicación, eventos de uso, logs de sesión, cookies y tecnologías similares.',
          'Datos on-chain: direcciones de billeteras operativas y referencias a transacciones ejecutadas en redes blockchain (por ejemplo, Solana) asociadas al producto Rewards.',
          'Datos de cumplimiento: resultados de consultas en listas restrictivas (OFAC, ONU, UE, listas vinculantes nacionales), debida diligencia y reportes de operaciones sospechosas cuando aplique.',
        ],
      },
      {
        text: 'No recopilamos a sabiendas datos de menores de edad. Si llegásemos a identificar que un titular es menor de edad, procederemos a suprimir los datos o a obtener la autorización correspondiente del representante legal según la normativa.',
      },
    ],
  },
  {
    question: 'Datos sensibles', // 4
    answers: [
      {
        text: 'Algunos datos biométricos recolectados para el proceso de KYC (por ejemplo, selfies y video-selfies utilizados para verificación facial) pueden ser considerados datos sensibles conforme a la Ley 1581 de 2012. Te informamos expresamente que:',
        subText: [
          'La entrega de datos sensibles es voluntaria; sin embargo, la verificación KYC es un requisito legal para la prestación del servicio, por lo que sin ella no podremos habilitar tu cuenta.',
          'El tratamiento se realiza únicamente para los fines de verificación de identidad, prevención de fraude y cumplimiento de obligaciones SAGRILAFT/UIAF.',
          'Los datos sensibles se almacenan con controles de seguridad reforzados, se comparten únicamente con Encargados del Tratamiento estrictamente necesarios (Bridge y/o proveedores KYC autorizados) y se conservan por el tiempo requerido por la normativa de prevención de LA/FT.',
        ],
      },
    ],
  },
  {
    question: 'Finalidades del tratamiento', // 5
    answers: [
      {
        type: 'circle',
        text: 'Los datos personales son tratados con las siguientes finalidades:',
        subText: [
          'Prestar los servicios de Flowex Pay: registro y administración de la cuenta, transferencias internacionales (ACH, SEPA, SPEI, PIX y otros rails), operación de la cuenta virtual en Estados Unidos, conversión de moneda y operación del producto Rewards on-chain (Kamino / USDC / Solana).',
          'Verificar tu identidad (KYC/KYB), evaluar riesgo y realizar monitoreo transaccional con fines de prevención de lavado de activos y financiación del terrorismo (SAGRILAFT).',
          'Cumplir obligaciones legales, regulatorias y contractuales, incluidos el reporte a la UIAF, la atención de requerimientos de autoridades judiciales, administrativas o de control, la retención de información por plazos legales y la respuesta a órdenes aplicables de autoridades colombianas o extranjeras.',
          'Prevenir y detectar fraudes, ciberataques, uso indebido de la plataforma o evasión de sanciones internacionales.',
          'Gestionar comunicaciones operativas y transaccionales (OTP, alertas de seguridad, notificaciones de estado de operaciones, cambios en términos o políticas).',
          'Ofrecerte, cuando autorices expresamente, comunicaciones comerciales, promocionales, encuestas o contenido relacionado con nuestros productos y aliados.',
          'Realizar análisis estadísticos agregados, mejora de producto, pruebas A/B y evaluación de desempeño, preferiblemente sobre datos anonimizados o seudonimizados.',
        ],
      },
    ],
  },
  {
    question: 'Base legal y autorización', // 6
    answers: [
      {
        text: 'El tratamiento se fundamenta en la autorización previa, expresa e informada del titular, otorgada al registrarse en la plataforma y al aceptar los Términos y Condiciones y esta Política. Adicionalmente, se fundamenta en el cumplimiento de obligaciones legales y regulatorias (por ejemplo, SAGRILAFT, UIAF, régimen cambiario, tributario y de sanciones), la ejecución del contrato con el titular y el interés legítimo de Flowex Pay en proteger su infraestructura y prevenir fraudes, siempre respetando los derechos del titular.',
      },
    ],
  },
  {
    question: '¿Con quién compartimos tus datos?', // 7
    answers: [
      {
        type: 'circle',
        text: 'Compartimos datos con Encargados del Tratamiento y terceros estrictamente necesarios para la prestación del servicio, bajo obligaciones contractuales de confidencialidad y seguridad. Entre ellos:',
        subText: [
          'Bridge: verificación KYC/KYB, emisión de cuenta virtual en Estados Unidos y ejecución de operaciones en rieles internacionales (ACH, SEPA, SPEI, PIX, y otros).',
          'Fireblocks: infraestructura de custodia institucional de activos digitales (tecnología MPC).',
          'Circle Internet Financial: emisor de USDC (moneda estable utilizada en el producto Rewards).',
          'Kamino Finance y terceros del ecosistema Solana: protocolo DeFi al cual se destinan voluntariamente los USDC en el producto Rewards. La información compartida con estos terceros corresponde a transacciones on-chain y a direcciones de billeteras operativas, NO a datos personales identificables del titular.',
          'Proveedores de mensajería (por ejemplo Twilio) para envío de OTP y notificaciones transaccionales.',
          'Proveedores de analítica, observabilidad, antifraude y soporte (en entornos controlados y con datos mínimos necesarios).',
          'Autoridades competentes: UIAF, DIAN, Superintendencia de Industria y Comercio, Fiscalía, jueces, Superintendencia Financiera o autoridades extranjeras equivalentes, cuando exista requerimiento legal.',
        ],
      },
      {
        text: 'Flowex Pay NO vende, NO alquila y NO cede a título oneroso o gratuito tus datos personales a terceros con fines publicitarios o de marketing externos.',
      },
    ],
  },
  {
    question: 'Transferencias y transmisiones internacionales', // 8
    answers: [
      {
        text: 'Algunos de nuestros Encargados (Bridge, Fireblocks, Circle, proveedores de mensajería y analítica) están domiciliados en los Estados Unidos u otras jurisdicciones. En consecuencia, tus datos podrán ser objeto de transferencia o transmisión internacional hacia países que la Superintendencia de Industria y Comercio no haya declarado formalmente como de nivel adecuado. En estos casos, Flowex Pay adopta medidas apropiadas —como cláusulas contractuales con estándares equivalentes a los colombianos, restricciones de uso y obligaciones de seguridad— para proteger tus datos, conforme al Decreto 1074 de 2015 y la Circular Externa 002 de 2015 de la SIC. Al aceptar esta Política autorizas dichas transferencias y transmisiones internacionales.',
      },
    ],
  },
  {
    question: '¿Cómo protegemos tus datos?', // 9
    answers: [
      {
        type: 'circle',
        text: 'Aplicamos medidas administrativas, técnicas y organizativas razonables para proteger la confidencialidad, integridad y disponibilidad de tus datos:',
        subText: [
          'Cifrado en tránsito (TLS) y cifrado en reposo para datos sensibles, cuando corresponde.',
          'Segmentación de redes, control de acceso basado en roles, principio de mínimo privilegio y trazabilidad (logs).',
          'Autenticación multifactor para operaciones sensibles del usuario (OTP) y para el acceso interno a sistemas críticos.',
          'Custodia institucional con tecnología MPC (Fireblocks) para activos digitales, con whitelisting y políticas de firma.',
          'Procesos de respuesta a incidentes y notificación a las autoridades y titulares cuando la normativa lo exija.',
          'Auditorías, pruebas de seguridad y revisión periódica de proveedores críticos.',
        ],
      },
      {
        text: 'A pesar de estas medidas, ningún sistema es totalmente inmune a incidentes. Flowex Pay no garantiza seguridad absoluta y no será responsable por eventos fuera de su control razonable, conforme a los límites de responsabilidad de los Términos y Condiciones.',
      },
    ],
  },
  {
    question: 'Conservación de la información', // 10
    answers: [
      {
        text: 'Conservamos tus datos personales durante la vigencia de la relación contractual y, posteriormente, por los plazos requeridos por la normativa aplicable para atender obligaciones de SAGRILAFT/UIAF, obligaciones tributarias, plazos de prescripción civil o comercial y eventuales requerimientos de autoridades. Cuando los datos dejen de ser necesarios y no exista deber legal de conservación, serán suprimidos o anonimizados.',
      },
    ],
  },
  {
    question: 'Derechos del titular', // 11
    answers: [
      {
        type: 'circle',
        text: 'En tu calidad de titular tienes, entre otros, los siguientes derechos:',
        subText: [
          'Conocer, actualizar y rectificar tus datos personales.',
          'Solicitar prueba de la autorización otorgada.',
          'Ser informado sobre el uso dado a tus datos, previa solicitud.',
          'Presentar quejas ante la Superintendencia de Industria y Comercio (SIC) por infracciones a la normativa de datos personales.',
          'Revocar la autorización y/o solicitar la supresión de tus datos, cuando no exista un deber legal o contractual que obligue a conservarlos.',
          'Acceder de forma gratuita a tus datos personales que hayan sido objeto de tratamiento.',
        ],
      },
    ],
  },
  {
    question: 'Procedimiento para ejercer derechos', // 12
    answers: [
      {
        type: 'circle',
        text: 'Para ejercer tus derechos, puedes enviar tu solicitud al correo soporte@flowexpay.com, indicando:',
        subText: [
          'Nombre completo, número de identificación y datos de contacto del titular o su representante.',
          'Descripción clara del derecho que deseas ejercer y de los hechos que motivan la solicitud.',
          'Documentos de soporte que quieras hacer valer (por ejemplo, copia del documento de identidad).',
        ],
      },
      {
        text: 'Las consultas serán atendidas en un plazo máximo de diez (10) días hábiles, prorrogables por cinco (5) días hábiles adicionales. Los reclamos serán atendidos en un plazo máximo de quince (15) días hábiles, prorrogables por ocho (8) días hábiles adicionales, conforme a los artículos 14 y 15 de la Ley 1581 de 2012. Si el reclamo está incompleto, se requerirá al titular para que lo subsane dentro de los cinco (5) días siguientes a la recepción.',
      },
    ],
  },
  {
    question: 'Cookies y tecnologías similares', // 13
    answers: [
      {
        text: 'Nuestro sitio web y aplicación móvil utilizan cookies, identificadores de dispositivo y tecnologías análogas para mantener la sesión, medir desempeño, prevenir fraudes y mejorar la experiencia. Puedes gestionar las cookies desde la configuración de tu navegador. La deshabilitación de cookies funcionales puede afectar el correcto funcionamiento del servicio.',
      },
    ],
  },
  {
    question: 'Permisos en la aplicación móvil', // 14
    answers: [
      {
        type: 'circle',
        text: 'La aplicación móvil de Flowex Pay solicita los siguientes permisos, únicamente cuando son necesarios para funciones específicas:',
        subText: [
          'Cámara y galería: para tomar fotografías del documento de identidad y selfies requeridos en el proceso KYC.',
          'Face ID / Touch ID / biometría del sistema operativo: para autenticación segura dentro de la aplicación. Los datos biométricos del sistema operativo NO se envían a nuestros servidores; permanecen en tu dispositivo.',
          'Notificaciones: para alertas transaccionales y de seguridad.',
        ],
      },
      {
        text: 'Puedes revocar estos permisos desde la configuración de tu dispositivo en cualquier momento. La revocación puede inhabilitar funciones específicas de la aplicación.',
      },
    ],
  },
  {
    question: 'Menores de edad', // 15
    answers: [
      {
        text: 'Flowex Pay no está dirigido a menores de dieciocho (18) años. No recolectamos deliberadamente datos personales de menores. Si un representante legal detecta que un menor a su cargo ha suministrado datos, deberá notificarlo a soporte@flowexpay.com para que procedamos a la supresión.',
      },
    ],
  },
  {
    question: 'Cambios a esta Política', // 16
    answers: [
      {
        text: 'Podremos actualizar esta Política en cualquier momento. Los cambios relevantes serán comunicados con al menos quince (15) días de antelación a través de correo electrónico y/o notificación en la plataforma. Si no estás de acuerdo con los cambios, podrás solicitar la supresión de tus datos o cerrar tu cuenta antes de su entrada en vigor. La fecha de última actualización se indica al final de este documento.',
      },
    ],
  },
  {
    question: 'Contacto', // 17
    answers: [
      {
        text: 'Para consultas, reclamos o ejercicio de derechos de habeas data:',
      },
      {
        text: 'Loaded Colombia SAS — marca "Flowex Pay"',
        subText: [
          'NIT: 901910428-1',
          'Domicilio: Bogotá D.C., Colombia',
          'Correo: soporte@flowexpay.com',
          'WhatsApp: +57 320 408 8142',
        ],
      },
      {
        text: 'También puedes presentar quejas ante la Superintendencia de Industria y Comercio (SIC), en su calidad de autoridad de protección de datos personales en Colombia.',
      },
    ],
  },
];

export default function Policy() {
  return (
    <div className="relative">
      <HeaderWithoutMenu />

      <section className="bg-[linear-gradient(to_right,rgba(0,0,0,0)_0%,#E7EFFF_100%)] py-6">
        <p className="px-10 sm:px-18 lg:px-22.5 py-4 sm:py-6 lg:py-8 font-[poppins] text-[#092F7B] text-[24px] sm:text-[32px] lg:text-[40px] font-semibold leading-[1.1] tracking-[-0.6px]">
          Política de tratamiento y protección de datos personales
        </p>

        <div className="px-8 sm:px-16 lg:px-20 py-2 sm:py-4 lg:py-6 space-y-6">
          <p className="font-[poppins] text-sm text-[#092F7B] font-normal leading-[1.5] tracking-[-0.6px]">
            En Flowex Pay (marca operada por Loaded Colombia SAS, NIT
            901910428-1) nos comprometemos a proteger la privacidad y seguridad
            de los datos personales de nuestros usuarios, clientes y aliados.
            Esta Política describe qué datos recolectamos, con qué finalidades
            los tratamos, con quién los compartimos, por cuánto tiempo los
            conservamos, cuáles son tus derechos como titular y cómo puedes
            ejercerlos. Se expide en cumplimiento de la Ley 1581 de 2012 y
            demás normas colombianas aplicables.
          </p>

          {Policies.map((item, i) => (
            <div key={i}>
              <p className="font-[poppins] text-sm text-[#092F7B] font-medium leading-[1.5] tracking-[-0.6px]">
                {`${i + 1}. ${item.question}`}
              </p>

              {item.answers.map((data, j) => (
                <div
                  key={j}
                  className="font-[poppins] text-sm text-[#092F7B] font-normal leading-[1.5] tracking-[-0.6px]"
                >
                  <p>{data.text}</p>

                  {data.subText && data.subText.length && (
                    <ul className="list-disc list-inside m-0 pl-4">
                      {data.subText.map((text, k) => (
                        <li key={k}>{text}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}

          <p className="font-[poppins] text-[11px] sm:text-xs text-[#092F7B] font-light leading-[1.5] tracking-[-0.6px] pt-4 italic">
            Última actualización: 19 de abril de 2026. Versión 2.0 — alineada
            con los Términos y Condiciones v2.0; incluye producto Rewards
            on-chain (Kamino / USDC / Solana), custodia institucional con
            Fireblocks, corredor Brasil (PIX), datos sensibles biométricos,
            transferencias internacionales de datos y procedimiento formal
            para el ejercicio de derechos conforme a la Ley 1581 de 2012.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
